import type { FC, PropsWithChildren } from 'react';
import TextBox from './TextBox.module.css';

type PhoneInputBoxProps = PropsWithChildren<{
  icon?: string;
  value: string;
  label: string;
  disabled?: boolean;
  placeholder: string;
  errorMessage?: string;
  style?: React.CSSProperties;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}>;

const PhoneInputBox: FC<PhoneInputBoxProps> = ({ placeholder, value, onChange, errorMessage, label, icon, style, disabled }) => {
  // const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   if (e.target.value.length < 13) {
  //     var cleaned = ('' + e.target.value).replace(/\D/g, '');

  //     let normValue = `${cleaned.substring(0, 3)}${cleaned.length > 3 ? '-' : ''}${cleaned.substring(3, 6)}${cleaned.length > 6 ? '-' : ''}${cleaned.substring(6, 11)}`;

  //     onChange(normValue);
  //   }
  // };

  return (
    <div className={TextBox.form_input}>
      {label && (
        <label htmlFor={label} className={TextBox.form_input__label}>
          {label}
        </label>
      )}
      <div className={TextBox.form_input__container} style={style}>
        {icon && (
          <svg className={TextBox.form_input__icon}>
            <use xlinkHref={`/assets/sprite.svg#icon-${icon}`} />
          </svg>
        )}
        <input
          type='text'
          id={label}
          disabled={disabled ? disabled : false}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          className={TextBox.form_input__box}
        />
      </div>
      {errorMessage && <p className={TextBox.form_input__error}>{errorMessage}</p>}
    </div>
  );
};

export default PhoneInputBox;
